import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SERVICES from "utils/constants/services";
import { fetchIntegrations } from "actions/integration";
import { fetchMerchantAccountProductsPrices } from "actions/merchantAccount";
import ProductShopifyIntegrationForm from "./ProductShopifyIntegrationForm";
import ProductSquarespaceIntegrationForm from "./ProductSquarespaceIntegrationForm";
import { useCtxReferences, useIntegrationForService } from "utils/selectors";
import SlimCTA from "components/SlimCTA";
import { interpolateRoute } from "utils/route";
import PATHS from "utils/paths";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import { ensureIntegrations } from "utils/hooks";
import { HUB_APP_SUB_SECTION } from "utils/constants/navigation";

const INTEGRATION_FORMS = {
  [SERVICES.SHOPIFY]: ProductShopifyIntegrationForm,
  [SERVICES.SQUARESPACE]: ProductSquarespaceIntegrationForm
};

const ProductIntegrations = ({ uid, actions }) => {
  ensureIntegrations({
    fetchIntegrations: actions.fetchIntegrations
  });
  const { application } = useCtxReferences();

  /**
   * Scoped to only squarespace for now
   * Would need to restrict product being connected to one service
   */
  const integration = useIntegrationForService(SERVICES.SQUARESPACE);

  const settingsRoute = `${interpolateRoute(PATHS.HUB_APPLICATIONS_SHOW, {
    application
  })}/${HUB_APP_SUB_SECTION.SETTINGS}`;

  if (integration) {
    const IntegrationForm = INTEGRATION_FORMS[integration.service];

    return <IntegrationForm uid={uid} integration={integration} />;
  } else {
    return (
      <SlimCTA
        customClasses={{
          header: "f5 fw5",
          subheader: "f6 lh-copy",
          container:
            "w-100 flex flex-column flex-row-ns justify-between items-start items-center-ns bg-white"
        }}
        header="No connected integration"
        subheader="To sync this product to an external source, connect an integration within your app settings."
        actions={[
          {
            classes: {
              contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
            },
            tag: "link",
            href: `${settingsRoute}?tab=integrations`,
            copy: "Connect"
          }
        ]}
      />
    );
  }
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchIntegrations,
      fetchMerchantAccountProductsPrices
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(ProductIntegrations);
